// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bgb_a bia_wj bia_ss bia_xl"};